import { Typography } from '@banhala/ui-kit';
import { useCountdownDisplay } from '../../GoodsInfo/components/PromotionCountdown/hooks/useCountdownDisplay';

export const TimerText = (props: { finishedAt: string }) => {
  // 넛지 스트립과 동일한 24h 규칙(useCountdownDisplay: 24h 이상 'N일'(올림), 미만 'HH:MM:SS', 만료 '00:00:00')
  const { text } = useCountdownDisplay(props.finishedAt);

  return (
    <Typography color={'content_pink_primary'} type={'subtitle3'}>
      {`${text} 남음`}
    </Typography>
  );
};
